import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {onMounted, onUnmounted, reactive} from "vue";
import BlockView from "@/components/block/BlockView.vue";
import BlockTitleView from "@/components/block/BlockTitleView.vue";
import {Json, mockArr, req} from "@/lib/util";
import emit from "@/lib/emit";

interface IActivityFootMark {
  activity_id: string
  title: string
  poster: string
  counter: Json | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockFootMark',
  setup(__props) {

const info = reactive({footprints: [] as IActivityFootMark[], loading: false})

onMounted(() => {
  mockArr('activities/foot/marks', 'get', 4, 20, {
    activity_id: '@id',
    title: '@ctitle(6,30)',
    poster: "@pick(['https://b.s.mywsy.cn/media/image/template/80041ff1ba8345894d1840382eb5c883.gif', 'https://b.s.mywsy.cn/media/image/template/4241ae73b4f20f325be716512bf9d530.gif', 'https://b.s.mywsy.cn/media/image/template/c29f10ad83b333e0c0b923f77059bf8b.png'])",
    status: {
      view: '@integer(10, 300)',
      sign: '@integer(1, 10)',
      share: '@integer(1, 30)',
      pay: '@integer(1, 8)',
    }
  })
  info.loading = true

  emit.on('templates.drafts.loaded', (e) => {
    req({
      url: 'activities/foot/marks', success: rs => {
        info.footprints = rs
      }, complete: () => info.loading = false
    })
  })
})

onUnmounted(() => {
  emit.off('templates.drafts.loaded')
})


return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createBlock(BlockView, {
    spinning: info.loading
  }, {
    default: _withCtx(() => [
      _createVNode(BlockTitleView, null, {
        default: _withCtx(() => [
          _createTextVNode("最近浏览的活动")
        ]),
        _: 1
      }),
      _createVNode(_component_a_list, {
        "data-source": info.footprints,
        split: "",
        bordered: "",
        pagination: {defaultPageSize:4,hideOnSinglePage:true,showSizeChanger:false}
      }, {
        renderItem: _withCtx(({ item }) => [
          _createVNode(_component_a_list_item, null, {
            actions: _withCtx(() => [
              _createVNode(_component_a_button, {
                onClick: ($event: any) => (_ctx.$router.push({path:'/editor',query:{activity_id:item.activity_id,opt:'copy'}}))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("复制 ")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_list_item_meta, {
                title: item.title,
                description: `已浏览：${item.counter?.['浏览次数'] ?? ''} 已报名：${item.counter?.['报名人数'] ?? ''} 已分享：${item.counter?.['分享次数'] ?? ''} 已成交：${item.counter?.['付款总额'] ?? ''}`
              }, {
                avatar: _withCtx(() => [
                  _createVNode(_component_a_avatar, {
                    src: item.poster
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1032, ["title", "description"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["data-source"])
    ]),
    _: 1
  }, 8, ["spinning"]))
}
}

})